<template>
  <footer class="relative z-50 bg-brand-dark text-white py-4 px-4 sm:px-0">
    <div class="container mx-auto max-w-6xl px-4">
      <div class=" pt-2 mt-2 flex flex-col md:flex-row justify-between items-start md:items-center">
        <p class="text-sm text-gray-300">© 2025 MeditationCircle.com All rights reserved. - Admin Panel</p>
        <p class="text-sm text-gray-300 mt-4 md:mt-0">Email: <a href="mailto:support@meditationcircle.com" class="hover:text-white">support@meditationcircle.com</a></p>
      </div>
    </div>
  </footer>
</template>

<script setup>
</script>

<style scoped>
</style> 